var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClockLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  rx: 22,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31 22C31 26.9706 26.9706 31 22 31C17.0294 31 13 26.9706 13 22C13 17.0294 17.0294 13 22 13C26.9706 13 31 17.0294 31 22ZM33 22C33 28.0751 28.0751 33 22 33C15.9249 33 11 28.0751 11 22C11 15.9249 15.9249 11 22 11C28.0751 11 33 15.9249 33 22ZM23.1429 18.0781C23.1429 17.4807 22.6652 17 22.0714 17C21.4777 17 21 17.4807 21 18.0781V22.75C21 23.0375 21.1116 23.3115 21.3125 23.4732L23.4554 25.6295C23.875 26.0877 24.5536 26.0877 24.933 25.6295C25.3884 25.2477 25.3884 24.5648 24.933 24.1426L23.1429 22.3053V18.0781Z",
  fill: "white"
})));
export default SvgClockLarge;